import React from "react";
import { useTransition, config, animated } from "react-spring";

import { DialogOverlay, DialogContent } from "@reach/dialog";

const AnimatedDialogOverlay = animated(DialogOverlay);
const AnimatedDialogContent = animated(DialogContent);

const AnimatedModal = props => {
  const { isOpen, onHide, focusRef = null, children, label = "modal", style = {}, className } = props;

  const modalTransition = useTransition(!!isOpen, {
    config: isOpen ? { ...config.stiff } : { duration: 150 },
    from: { opacity: 0, transform: `translate3d(0px, -10px, 0px)` },
    enter: { opacity: 1, transform: `translate3d(0px, 0px, 0px)` },
    leave: { opacity: 0, transform: `translate3d(0px, 10px, 0px)` }
  });

  return modalTransition(
    (styles, isOpen) =>
      isOpen && (
        <AnimatedDialogOverlay
          className={className}
          allowPinchZoom
          initialFocusRef={focusRef}
          onDismiss={onHide}
          isOpen={isOpen}
          style={{ opacity: styles.opacity }}
        >
          <AnimatedDialogContent
            style={{
              ...style,
              ...styles
            }}
            aria-label={label}
          >
            {
              React.Children.map(children, child => {
                return !child
                  ? null
                  : typeof child.type === 'string'
                    ? child
                    : React.cloneElement(child);
              })
            }
          </AnimatedDialogContent>
        </AnimatedDialogOverlay>
      )
  );
};

export default AnimatedModal;
